import { ValidatorFn } from "@angular/forms";
import { ApiService } from "../../shared/shared/interfaces/api-service"
import { ObjFields } from "../../shared/shared/types/obj-fields";

export abstract class FormConfig<T> {
    fields : Array<FormField<T> | FormField<T>[]>;
    buttons : FormButtonType[];
    
    toKeyValue = (values : any[], key : string, value : string) : {key : string, value : any}[] => values.map(v => { return {'key' : key ? v[key] : v, 'value' : value?  v[value] : v}});
    init?(args? : any) : void;
    apiService?() : ApiService<T>;
    fieldsInit(obj : any){
        obj.fields.forEach(f => {
            if(f.init) f.init(f);
        });
    }
}

export class FormField<T>{
    /** Field name from the T entity. CUSTOME CONTROL: use an array of fields to define the custome element input */
    name :  ObjFields<T> | Array<ObjFields<T>> | '';
    type : 'dropdown' | 'text' | 'textarea' | 'radio' | 'date' | 'file' | 'dateRange' | 'checkbox' | 'visibleDateRange';
    readonly? : boolean;
    /** To use a different name that defined in name. CUSTOME CONTROL: Requierd. since name could be an array */
    controlName? :  string;
    label? : string;
    /** CUSTOME CONTROL: prefix label to use inside the component */
    labelPre? : string;
    required? : boolean;
    options? : {key : string, value : any}[];
    value? : any;
    validators? : ValidatorFn[];
    inline? : boolean;
    description? : string;
    main? : boolean;
    init? : (field : FormField<T>) => void;
}

export class FormFieldArray<T>{
    title : string;
    fields : FormField<T>[];
}

export type FormButtonType = "ADD" | "ADD_AND_CLOSE" | "CANCEL" | "CREATE" | "SAVE"; 